import React from 'react';
import { useStyletron } from 'baseui';
export const TimelineDivider = ({
  left
}: {
  left: number;
}) => {
  const [css, theme] = useStyletron();
  return <div data-testid="timeline-divider" className={css({
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    left: `${left}px`,
    width: '1px',
    backgroundColor: theme.colors.borderOpaque
  })} />;
};